var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"splashback"}},[_c('div',{attrs:{"id":"splash"}},[_c('center',[_c('img',{attrs:{"id":"splash","src":"/assets/splash.png","alt":"SecondOeuvre"}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }